interface IConfig {
  feature: {
    staticConfiguration: boolean;
  };
  buildType: string;
  buildStage: string;
  firebase: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
    firestore: { local: boolean; host: string; port: number };
    functions: { local: boolean; host: string; port: number };
    auth: { local: boolean; host: string };
    database: { local: boolean; host: string; port: number };
    storage: { local: boolean; host: string; port: number };
  };
  apiUrl: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildConfig(env: any): IConfig {
  return {
    feature: {
      staticConfiguration: env.REACT_APP_FEATURE_STATIC_CONFIGURATION === 'true' ? true : false,
    },
    buildStage: env.REACT_APP_STAGE,
    buildType: env.NODE_ENV,
    apiUrl: env.REACT_APP_API_URL,
    firebase: {
      apiKey: env.REACT_APP_FIREBASE_API_KEY,
      authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: env.REACT_APP_FIREBASE_REALTIME_DATABASE_URL,
      projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: env.REACT_APP_FIREBASE_APP_ID,
      measurementId: env.REACT_APP_FIREBASE_MEASUREMENT_ID,
      firestore: {
        local: env.REACT_APP_FIREBASE_FIRESTORE_LOCAL === 'true' ? true : false,
        host: env.REACT_APP_FIREBASE_FIRESTORE_HOST,
        port: env.REACT_APP_FIREBASE_FIRESTORE_PORT,
      },
      functions: {
        local: env.REACT_APP_FIREBASE_FUNCTIONS_LOCAL === 'true' ? true : false,
        host: env.REACT_APP_FIREBASE_FUNCTIONS_HOST,
        port: env.REACT_APP_FIREBASE_FUNCTIONS_PORT,
      },
      database: {
        local: env.REACT_APP_FIREBASE_DATABASE_LOCAL === 'true' ? true : false,
        host: env.REACT_APP_FIREBASE_DATABASE_HOST,
        port: env.REACT_APP_FIREBASE_DATABASE_PORT,
      },
      auth: {
        local: env.REACT_APP_FIREBASE_AUTH_LOCAL === 'true' ? true : false,
        host: env.REACT_APP_FIREBASE_AUTH_HOST,
      },
      // storage emulator possible announcement at google i/o 2021
      // https://events.google.com/io/session/21e0d8b3-cf63-4931-a6d7-ab8a8e2b10c9?lng=en
      // firebase --open-sesame storageemulator
      // > Enabling preview feature storageemulator...
      // > Preview feature enabled!
      storage: {
        local: env.REACT_APP_FIREBASE_STORAGE_LOCAL === 'true' ? true : false,
        host: env.REACT_APP_FIREBASE_STORAGE_HOST,
        port: env.REACT_APP_FIREBASE_STORAGE_PORT,
      },
    },
  };
}

export default buildConfig(process.env);

export { buildConfig };
